import Modal from './accessibility';
import {documentReady, debouncer} from '../Utility/utils';

documentReady(event => {
  // Menu Toggle
  const nav = document.querySelector('.main-navigation');
  const firstMenu = nav.querySelector('.main-navigation__menu');
  const navModalBar = firstMenu.querySelector('.main-navigation__bar');
  const firstMenuContainer = nav.querySelector('.main-navigation__menu__container');
  const secondMenu = nav.querySelector('.main-navigation__menu__second-container');
  const menuToggle = nav.querySelectorAll('.nav-trigger');
  const secondMenuToggle = nav.querySelector('.second-nav-trigger');
  const closeSecondNav = nav.querySelector('.close-second-nav');
  const body = document.querySelector('body');
  const inViewportTimeout = 400;

  const navBarFocusTrap = () => {
    const navLinks = navModalBar.querySelectorAll('a');
    if(nav.classList.contains('active')){
      navLinks.forEach(element => {
        element.setAttribute('tabindex', '1');
      });
    }
    else {
      navLinks.forEach(element => {
        element.setAttribute('tabindex', '-1');
      });
    }
  }

  const toggleFirstMenu = () => {
    nav.classList.toggle('active');

    if(nav.classList.contains('active')){
      openFirstMenu();
    }
    else {
      closeFirstMenu();
    }
  }

  const openFirstMenu = () => {
    firstMenu.setAttribute('aria-hidden', 'false');
    firstMenuContainer.classList.add('in-viewport');
    // Handles trapping focus in modal
    body.classList.add('scroll-lock');
    Modal.open(firstMenuContainer);
    navBarFocusTrap();
  }

  const closeFirstMenu = () => {
    firstMenu.setAttribute('aria-hidden', 'true');
    setTimeout(()=>{
      firstMenuContainer.classList.remove('in-viewport');
    },inViewportTimeout);
    // Handles un-trapping focus in modal
    body.classList.remove('scroll-lock');
    Modal.close(firstMenu);
    navBarFocusTrap();
  }

  const toggleSecondMenu = () => {
    if( nav.classList.contains('second-nav') ) {
      openSecondMenu();
    }
    else {
      closeSecondMenu();
    }
  }

  const openSecondMenu = () => {
    secondMenu.setAttribute('aria-hidden','false');
    secondMenu.classList.add('in-viewport');
    Modal.open(secondMenu);
    navBarFocusTrap();
  }

  const closeSecondMenu = () => {
    nav.classList.remove('second-nav');
    secondMenu.setAttribute('aria-hidden','true');
    Modal.open(firstMenuContainer);
    navBarFocusTrap();

    setTimeout(()=>{
      secondMenu.classList.remove('in-viewport');
    },inViewportTimeout);
  }

  menuToggle.forEach(item => {
    item.addEventListener('click', function(e){
      closeSecondMenu();
      toggleFirstMenu();

      document.addEventListener('keydown', function(event){
        if(event.key === "Escape" && nav.classList.contains('active')) {
          closeSecondMenu();
          toggleFirstMenu();
        }
      });

    });
  });

  // second level curtain
  if(!!secondMenuToggle){
    secondMenuToggle.addEventListener('click', function(e){
      nav.classList.toggle('second-nav');
      toggleSecondMenu();
    });
  }

  if(!!closeSecondNav){
    closeSecondNav.addEventListener('click', function(e){
      closeSecondMenu();
    });
  }

  // Set menu state on load and resize if changing from mobile to desktop.
  function set_menu_state(){
    // Since we don't know the menu breakpoint, check if the menu toggle is visible
    const is_desktop = menuToggle.offsetParent === null ? true : false;

    // Desktop
    if(is_desktop){
      // if mobile state classes are present, remove them.
      if(nav.classList.contains('active')){
        nav.classList.remove('active');
      }
    }
    // Mobile
    else {

    }
  }
  set_menu_state();

  // Resize modals on window resize
  window.addEventListener('resize', debouncer(function(){
    set_menu_state();
  }, 15));



  // changes nav bg color based on "nav-color" data attribute per each section
  const navBar = nav.querySelector('.main-navigation__bar');
  const hero = document.querySelector('.hero');
  if( hero.dataset.navColor ) {
    navBar.style.setProperty('--nav-bg-color', hero.dataset.navColor);
  } else {
    navBar.style.setProperty('--nav-bg-color', '#000000');
    navBar.style.setProperty('--nav-text-color', '#ffffff');
  }
  if( hero.dataset.navIconColor ) {
    navBar.style.setProperty('--nav-text-color', hero.dataset.navIconColor);
  }

  const navColorObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if( entry.isIntersecting ) {
        let bgColor = entry.target.dataset.navColor;
        let textColor = entry.target.dataset.navIconColor;
        navBar.style.setProperty('--nav-bg-color', bgColor ?? 'transparent');
        navBar.style.setProperty('--nav-text-color', textColor ?? '#000000');
      }
    });
  }, {
    "rootMargin": "-50% 0% -50% 0%",
  "threshold": 0
  });

  document.querySelectorAll('[data-nav-color]').forEach( changer => {
    // changer.style.setProperty('background-color', changer.dataset.navColor); //this is just to know which is which
    navColorObserver.observe(changer);
  });


  // changes share text color based on "share-text-color" data attribute per each section
  const shareEl = document.querySelector('.hero__share');
  if( hero.dataset.shareTextColor ) {
    shareEl.style.setProperty('--share-color', hero.dataset.shareTextColor);
  }

  const shareColorObserver = new IntersectionObserver((entries, observer) => {
    const isSimplePost = body.classList.contains('post-basic');
    let i = 0;
    let sectionstates = [];
    let color;
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        sectionstates[i] = 'true';
        if(entry.target.dataset.shareTextColor){
          color = entry.target.dataset.shareTextColor;
        }
        else if(isSimplePost){
          color = '#FFFFFF';
        }
      }
      else {
        sectionstates[i] = 'false';
      }
      i++;
    });

    if(!sectionstates.includes('true')){
      color = '#202020';
    }

    if(!!shareEl){
      shareEl.style.setProperty('--share-color', color ?? '#202020');
    }
  }, {
    "rootMargin": "-25% 0% -75% 0%",
  "threshold": 0
  });

  document.querySelectorAll('[data-share-text-color]').forEach( changer => {
    // changer.style.setProperty('background-color', changer.dataset.navColor); //this is just to know which is which
    shareColorObserver.observe(changer);
  });

  if(body.classList.contains('post-basic')){
    document.querySelectorAll('.page-section.section__bg, .hero, .entry-footer, .footer').forEach( changer => {
      // changer.style.setProperty('background-color', changer.dataset.navColor); //this is just to know which is which
      shareColorObserver.observe(changer);
    });
  }

});
